import { render, staticRenderFns } from "./block-atlas.vue?vue&type=template&id=77988f26&scoped=true"
import script from "./block-atlas.vue?vue&type=script&lang=js"
export * from "./block-atlas.vue?vue&type=script&lang=js"
import style0 from "./block-atlas.vue?vue&type=style&index=0&id=77988f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77988f26",
  null
  
)

export default component.exports